<template>
  <div id="contacts">
    <h1 class="page-title">
      Vamos
      <span class="highlight">conversar?</span>
    </h1>
    <div id="contacts-content">
      <div id="other-contacts">
        <!-- <h2 id="ou">ou</h2> -->
        <div id="contacts-container">
          <h2>Fale com a gente nas redes sociais</h2>
          <ul>
            <li v-for="socialMedia in contacts.socialMedias" :key="socialMedia.name">
              <a :href="socialMedia.url">
                <font-awesome-icon :icon="socialMedia.icon"></font-awesome-icon>
                {{socialMedia.perfilName}}
              </a>
            </li>
          </ul>
          <h2>envie um email para nós</h2>
          <a :href="'mailto:' + contacts.email">{{contacts.email}}</a>
          <h2>ligue ou mande uma mensagem</h2>
          <a :href="'tel:' + contacts.phone">{{contacts.phone}}</a>
          <h2>venha nos visitar</h2>
          <a href="https://goo.gl/maps/cWJgaD46LDDHnK8Q9">{{address}}</a>
        </div>
      </div>
      <ContactForm id="contact-form" />
    </div>
  </div>
</template>

<script>
import ContactForm from "@/components/ContactForm";
export default {
  components: {
    ContactForm
  },
  computed: {
    contacts() {
      return this.$store.state.contacts;
    },
    address() {
      return this.$store.state.address;
    }
  }
};
</script>

<style scoped lang="scss">
#contacts-content {
  @include reset-css();
  width: 100%;
  // padding: 20px;
  display: grid;
  grid-gap: 30px;
  @include for-tablet-portraid-up {
    // align-content: center;
    grid-template-columns: 1fr 1fr;
    // justify-items: center;
  }
}

#contacts-container {
  align-self: center;
  // border-left: 5px $verde-exception solid;
  // padding-left: 20px;

  h2 {
    color: $verde-exception;
    font-size: 1.5rem;
    margin-bottom: 5px;
    @include for-tablet-landscape-up {
      // font-size: 1.5rem;
    }
  }
  ul {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    li {
      margin-right: 20px;
      // font-size: 1.5rem;
      a {
        display: flex;
        align-items: center;
        margin-bottom: 0;
      }
    }
    svg {
      font-size: 1.5rem;
      margin-right: 5px;
    }
  }
  a {
    font-family: $fonte-secundaria;
    color: $cor-primaria;
    text-decoration: none;
    margin: 0;
    margin-bottom: 30px;
    font-weight: 500;
    font-size: 1rem;
    line-height: 1.5rem;
    @include for-tablet-landscape-up {
      // font-size: 1rem;
      // line-height: 1.5rem;
    }
  }
}
#contact-form {
  justify-self: center;
}
</style>